import Price from '@/components/Price';
import { PosUIConfig } from '@/models/pos';
import { SKUWrapper } from '@/models/sku';
import { COLOR_SUCCESS, useSkuImg } from '@/utils/uiHelper';
import { ClockCircleFilled, ClockCircleTwoTone, FieldTimeOutlined } from '@ant-design/icons';
import { Badge, Card as CardView, Flex, Typography } from 'antd';
import React, { memo } from 'react';
import { useStyles } from './spuItem.style';

type Props = {
  loading?: boolean;
  previewMode?: boolean;
  titleRows?: number;
  imgHeight?: number;
  imgMode?: PosUIConfig['coGoodsImgMode'];
  skuWrapper: SKUWrapper;
  onItemClick?: (skuWrapper: SKUWrapper) => void;
  columnIndex: number;
};
const SpuItem: React.FC<Props> = ({
  loading = false,
  columnIndex,
  skuWrapper,
  onItemClick,
  previewMode = false,
  imgHeight = 130,
  imgMode = 'cover',
  titleRows = 1,
}: Props) => {
  const { styles } = useStyles();
  const getSkuImg = useSkuImg();

  const sku = skuWrapper.goods;
  const specifications = skuWrapper.specifications;

  return (
    <div className={`${styles.skuItem} ${columnIndex === 0 ? 'first' : ''}`}>
      <CardView
        loading={loading}
        onClick={() => {
          onItemClick && onItemClick(skuWrapper);
        }}
        size={'small'}>
        <>
          <div className={styles.skuItemTitle}>
            <div className={styles.skuItemTitleText} style={{ height: 22 * titleRows }}>
              <Typography.Paragraph
                style={{ margin: 0 }}
                ellipsis={{
                  rows: titleRows,
                }}>
                {sku.name}
              </Typography.Paragraph>
            </div>
          </div>

          {imgHeight > 0 ? (
            <div
              className={styles.skuItemImg}
              style={{
                height: imgHeight,
                backgroundImage: `url(${getSkuImg(sku.picUrl, previewMode ? 200 : Math.ceil(imgHeight / 100) * 100)})`,
                backgroundSize: imgMode,
              }}>
              {/*<img alt={sku.name} src={`${assetsPrefix}${sku.picUrl}`} draggable={false} />*/}
            </div>
          ) : null}

          <div className={styles.skuItemBrief}>
            {specifications.length > 1 ? (
              '多种规格'
            ) : (
              <Flex gap={10}>
                <span>
                  {specifications[0].stock > 50 ? (
                    <Badge color={'green'} text={<>库存充足</>} />
                  ) : (
                    <>库存: {specifications[0].stock}</>
                  )}
                </span>
                {sku.duration ? (
                  <span>
                    <ClockCircleTwoTone twoToneColor={COLOR_SUCCESS} /> {sku.duration}
                  </span>
                ) : null}
                <span style={{ marginLeft: 'auto' }}>
                  <Price value={specifications[0].price} />
                </span>
              </Flex>
            )}
          </div>
        </>
      </CardView>
    </div>
  );
};

export default memo(SpuItem);
